import { jsxs as u, jsx as e } from "@emotion/react/jsx-runtime";
import { memo as p, useState as h, useRef as s, Fragment as A } from "react";
import { useTheme as C } from "@emotion/react";
import { convertToRgba as b, HEX_COLORS as m } from "@partoohub/branding";
import { Avatar as c, FontAwesomeIconsPartooUsed as g, IconPrefix as O } from "@partoohub/ui";
import { useClickOutside as k } from "../../hooks/useClickOutside.js";
import { AvatarPanelContainer as v, AvatarMenuContent as x } from "./AvatarPanel.styled.js";
import { PARTOOROBOT_AVATAR_PANEL as R } from "../../constants/index.js";
import { getInitial as P } from "../../utils/string.js";
const S = p(({
  user: o,
  items: t = []
}) => {
  const f = C(), [r, a] = h(!1), n = s(null), l = s(null), d = () => {
    a(!r);
  };
  return k({
    refs: [n, l],
    onClickOutside: () => {
      a(!1);
    }
  }), /* @__PURE__ */ u(v, { "data-partoorobot": R, onClick: d, ref: n, children: [
    o && (o.first_name || o.last_name) ? /* @__PURE__ */ e(c, { size: 32, text: o ? P(o) : "", textSize: 14, backgroundColor: `${f.colors.default.background}` }) : /* @__PURE__ */ e(c, { size: 32, image: [g.faUser, O.SOLID], textColor: m.blackberry, iconSize: "16px", backgroundColor: b(m.blackberry, 0.12) }),
    r && t?.length > 0 && /* @__PURE__ */ e(x, { ref: l, children: t.map((i) => /* @__PURE__ */ e(A, { children: i.label }, i.id)) })
  ] });
});
S.displayName = "AvatarPanel";
export {
  S as AvatarPanel
};
